import { Box, IconButton, TextField } from "@mui/material"
import { useState } from "react"
import Add from "@mui/icons-material/Add"
import Remove from "@mui/icons-material/Remove"
import OotItemContextMenuButton from "../hints/OotItemContextMenuButton"
import { SimpleDekuShieldItem } from "../inventory/items/DekuShieldItem"
import { SimpleHylianShieldItem } from "../inventory/items/HylianShieldItem"
import { SimpleBlueFireBottleItem } from "../inventory/items/BlueFireBottleItem"
import { SimpleGoldenSkultulaItem } from "../inventory/items/TokenCounterItem"
import { SimpleGoronTunicItem } from "../inventory/items/GoronTunicItem"
import { SimpleZoraTunicItem } from "../inventory/items/ZoraTunicItem"
import { OotItemDto } from "../hints/OotItemAutocomplete"
import { isNil } from "lodash"

export interface ShopItemsDto {
    index: number
    item: OotItemDto | null,
    price: string
}
export interface ShopDto {
    id: number,
    name: string | null,
    shopItems: Array<ShopItemsDto>
}
export interface ShopsanityTrackerProps {
    nbShops?: number
    shops?: Array<ShopDto>
    setShopItem?: (id: number, name: string | null, index: number, item: OotItemDto | null, price: string) => void
}

const ShopsanityTracker = (props: ShopsanityTrackerProps) => {

    let [nbShop, setNbShop] = useState(1)

    return  <Box
    display={"flex"}
    flexDirection={"column"}
  >
    <Box display={"flex"}>
        <SimpleDekuShieldItem /> <SimpleHylianShieldItem /> <SimpleBlueFireBottleItem /> <SimpleGoldenSkultulaItem /> <SimpleGoronTunicItem /> <SimpleZoraTunicItem />
    </Box>
    {isNil(props.shops) && Array.from(Array(nbShop).keys()).map(i => 
    {
        return <ShopTracker />
   
    })}
    {!isNil(props.shops) && props.shops.map(s => {
        return <ShopTracker shop={s} setShop={(name, index, item, price) => {if(!isNil(props.setShopItem)) props.setShopItem(s.id, name, index, item, price)}}/>
    })}
    <Box display={"flex"} flexDirection={"row"}>{nbShop > 1 && <IconButton onClick={() => setNbShop(nbShop-1)}><Remove /></IconButton>} {nbShop <= 8 && <IconButton onClick={() => setNbShop(nbShop+1)}><Add /></IconButton>}</Box>
    
    </Box>
}

export default ShopsanityTracker



interface ShopTrackerProps {
    shop?: ShopDto,
    setShop?: (name: string | null, index: number, item: OotItemDto | null, price: string) => void
}

const ShopTracker = (props: ShopTrackerProps) => {

    let [itemPrice1, setItemPrice1] = useState<string>(props.shop?.shopItems[0].price ?? "0");

    return <Box display={"flex"}>
        <TextField placeholder="Shop Entrance" value={props.shop?.name} onBlur={(v) => {if(!isNil(props.setShop)) props.setShop(v.currentTarget.value, 0, props.shop?.shopItems[0].item ?? null, itemPrice1)}} variant="standard" sx={{width: "150px", height: "30px", maxHeight: "30px"}}/>
        <OotItemContextMenuButton item={props.shop?.shopItems[0].item} onItemChange={(i) => {if(!isNil(props.setShop)) props.setShop(props.shop?.name ?? null, 0, i, ((props.shop?.shopItems[0].price) ?? 0).toString())}}/>
        <TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}} value={itemPrice1} onChange={(v) => setItemPrice1(v.currentTarget.value)} onBlur={(v) => {if(!isNil(props.setShop)) props.setShop(props.shop?.name ?? null, 0, props.shop?.shopItems[0].item ?? null, itemPrice1 )}}/>
        <OotItemContextMenuButton />
        <TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/>
        <OotItemContextMenuButton />
        <TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/>
        <OotItemContextMenuButton />
        <TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/>
    </Box>
}